// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '1.1.5';
export const APP_NAME = 'booking';
export const FILE_HASH = '1703762023225';
export const BUILD_DATE = '2023-12-28T11:13:43.225Z';
/* tslint:enable */
